import styles from './SportsViewMoreBetsModal/SportsViewMoreBetsModal.module.css'

/**
 * SettlementVoidModal – common confirm dialog for every "void" action in the
 * Settlement section (per-bet void, post-settlement market/bet void, casino
 * round/bet void).
 *
 * Uses the same overlay chrome as SettlementModal so the whole section looks
 * like one thing. Transaction password field is optional — server maangta hai
 * sirf un endpoints par jo user ke paise seedha badalte hain.
 *
 * Props:
 *   show, title, onHide, onConfirm, submitting
 *   requirePassword, password, onPasswordChange
 *   confirmLabel, error, children (body content)
 */
export default function SettlementVoidModal({
  show,
  title = 'Confirm Void',
  onHide,
  onConfirm,
  submitting = false,
  requirePassword = false,
  password = '',
  onPasswordChange,
  confirmLabel = 'Confirm Void',
  error = '',
  children,
}) {
  if (!show) return null

  const disabled = submitting || (requirePassword && !password)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (disabled) return
    onConfirm?.()
  }

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalDialogSmall}>
        <div className={styles.viewMoreModalContent}>
          <div className={styles.modalHeader}>
            <h5 className={styles.modalTitle}>{title}</h5>
            <button type="button" className={styles.closeButton} onClick={onHide} aria-label="Close">
              &times;
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className={styles.modalBody}>
              <div className="alert alert-warning mb-0">{children}</div>

              {requirePassword && (
                <div className="mt-3">
                  <label className="form-label fw-bold mb-1">Transaction Password</label>
                  <input
                    type="password"
                    className="form-control form-control-sm"
                    value={password}
                    autoComplete="off"
                    onChange={(e) => onPasswordChange?.(e.target.value)}
                  />
                </div>
              )}

              {error && <div className="alert alert-danger mt-3 mb-0 py-2">{error}</div>}

              <div className="d-flex justify-content-end gap-2 mt-3">
                <button type="button" className="btn btn-secondary btn-sm" onClick={onHide}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-danger btn-sm" disabled={disabled}>
                  {submitting ? 'Processing...' : confirmLabel}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
